import { baseApi } from "./baseApi";

export const deeplinkApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    generateDeeplinkUrl: builder.mutation({
      query: (data) => ({
        url: "admin/generate-deeplink-url",
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
    }),
  }),
});

export const { useGenerateDeeplinkUrlMutation } = deeplinkApi;
